/**
 * @fileoverview Ant Design DatePicker locale mapping for Reports.
 * @module pages/reports/reportLocale
 */
import locale from "antd/es/date-picker/locale/es_ES";

/** Returns the Ant Design date-picker locale for the active i18n language. */
export const getReportDatePickerLocale = (language) => {
  switch (language) {
    case "es":
      return locale;
    case "en":
      return require("antd/es/date-picker/locale/en_US").default;
    case "fr":
      return require("antd/es/date-picker/locale/fr_FR").default;
    default:
      return locale;
  }
};
